const placeholderDescr = 'Description goes here: takeback takeback takeback takeback takeback takeback takeback' +
  ' takeback takeback takeback takeback takeback takeback takeback takeback takeback takeback takeback' +
  ' takeback takeback takeback takeback takeback takeback takeback takeback takeback takeback takeback' +
  ' takeback takeback takeback takeback takeback takeback takeback takeback takeback takeback takeback takeback ';

// const links = [
//   ['Find a Location', 'map'],
//   ['Texting Service', 'text'],
//   ['FAQ', 'faq'],
//   ['Toolkit', 'toolkit'],
//   ['About', 'about'],
// ];

export const headerCopy = {
  description: 'Ready to help out? Search below to find a safe place to get rid of unused medication near you.',
  description2: 'This list of locations was last updated in March 2018. Make sure to call any listed locations to confirm that drop-offs are accepted.',
  description3: 'Click on any site that pops up in your search results to move the map.',
};

// const mapCopy = {
//   description: 'Find my nearest drop-off location',
// };

export const aboutCopy = {
  link: ['Find A Location', 'Find', 'map'],
  title: 'About The Opioid Crisis',
  description1: 'The opioid crisis is the deadliest drug overdose crisis in American history.',
  description2: 'Today in the United States, more people are killed by drug overdoses than by car crashes. Drug overdoses are the leading cause of death for Americans under 50. And in some states hardest-hit by the crisis, there are more prescriptions than there are residents. Families across New York have been devastated as their loved ones struggle with addiction.',
  description3: 'It is essential that we do everything possible to prevent future addictions in addition to combatting the opioid crisis today. This is why the small step you can take by bringing your unused prescription drugs to a nearby drop-off site is an incredibly important part of the public health efforts to turn the opioid crisis around.',
  description4: 'More than 42,000 pounds of unused medication were collected in New York State during the last National Prescription Drug Take Back Day. We need your help to keep the progress going and spread the word.'
};

export const faqCopy = {
  title: 'Frequently Asked Questions',
  description: placeholderDescr,
  faqs: [
    {
      question: 'What is Clear Your Cabinet?',
      answer: [
        'Clear Your Cabinet is an initiative of the New York AG’s Office to reduce the ' +
        'amount of unused prescription drugs in New Yorkers’ medicine cabinets. This is a crucial way that we can ' +
        'all help to fight the opioid crisis that is devastating families across New York and our country.',
        'Research shows that a majority of abused prescription drugs are obtained from family and friends, and the source is ' +
        'often from medication that was prescribed but never finished and left to sit at home.',
        'This site was built through a collaboration with volunteers from some of New York’s leading tech startups, beginning with a hackathon on the opioid crisis hosted by the Attorney General’s office in March 2018. Special thanks to Progressive Hacknight and Civic Hall for their assistance.',
      ],
    },
    {
      question: 'So there are designated sites across New York where I can bring my unused medication?',
      answer: [
        'Yes.',
        'New York State, the federal government, national and community pharmacies, and non-profits ' +
        'across New York have responded to our national opioid crisis by setting up safe drop-off sites for New ' +
        'Yorkers to bring unused medication. We have worked to combine all the available sources of information about ' +
        'where you can find these drop-off sites into the site locator above.',
      ],
    },
    {
      question: 'Will I get in trouble for dropping off prescription drugs and unused over-the-counter medication?',
      answer: [
        'No. If you bring in your medication, you’re fine.',
      ],
    },
    {
      question: 'Is there a charge for disposing my medications?',
      answer: [
        'No, the service is free.',
      ],
    },
    {
      question: 'Do these sites collect medication year-round?',
      answer: [
        'Many sites are year-round, but some are only for a short period of time during National Prescription ' +
        'Drug Take Back Day, a twice-yearly effort coordinated by the DEA.',
        'We recommend calling sites found on the ' +
        'locator before you head out, and confirming their availability and hours.',
      ],
    },
  ],
};

export const resourceCopy = {
  title: 'Resources',
  description: 'Help spread the word - get the flyer',
};

export const NYAGCopy = {
  title1: 'An Initiative of The',
  title2: 'New York AG’s Office',
  description: 'Clear Your Cabinet is the latest initiative of The New York Attorney General’s ' +
  'comprehensive campaign to address the opioid crisis. Some of the Attorney General’s most significant achievements on behalf of New Yorkers include:',
  // bullets have links - copy is hardcoded in component
};

export const footerCopy = {
  home: ['Home', 'top'],
  contact: ['Get in Touch', ''],
  acknowlegements: [['Acknowledgements', '']],
};


// WEBPACK FOOTER //
// ./src/copy.js